import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://erp-lab-api.adaptivevelocity.me';
const TOKEN_KEY = 'auth_token';
const TENANT_HEADER = 'X-Tenant-Id';

let impersonatedTenantId: string | null = null;
let defaultTenantId: string | null = null;

export function setImpersonatedTenant(tenantId: string | null) {
  impersonatedTenantId = tenantId;
}

export function setDefaultTenant(tenantId: string | null) {
  defaultTenantId = tenantId;
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Inject Bearer token + optional tenant header on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const tenantId = impersonatedTenantId || defaultTenantId;
  if (tenantId) {
    config.headers[TENANT_HEADER] = tenantId;
  }
  return config;
});

// Handle 401 — redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export function setAuthToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getAuthToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getCurrentTenantId(): string | null {
  return impersonatedTenantId || defaultTenantId;
}

export default api;
